// Unable to test, page not displaying locally
const init = () => {
    const newsFilterSelections = document.querySelectorAll(
        ".newslist .page-hero .form__select");
    if (!newsFilterSelections) return

    newsFilterSelections.forEach(option => {
        option.addEventListener('change', (e) => {
            const filtertype = e.target.id
            const filterEvent = e.target.selectedOptions[0].text
            const isAuthenticated = String(window.authenticated)

            dataLayer.push({
                'event': 'newsFilter',
                'filterTyp': filtertype.charAt(0).toUpperCase() + filtertype.slice(1).toLowerCase(),
                'filterValue': filterEvent,
                'isAuthenticated': isAuthenticated.charAt(0).toUpperCase() + isAuthenticated.slice(1).toLowerCase(),
                'selectedBranch': getBranchName()
            })
        })
    })

    function getBranchName() {
        const branchBtn = document.querySelector('.branch__open');
        if (!branchBtn) return
        let branchName = branchBtn.innerText
        return branchName.toUpperCase().includes('BRANSCH') ? null : branchName.charAt(0).toUpperCase() + branchName.slice(1).toLowerCase()
    }
}

document.addEventListener("DOMContentLoaded", () => init())
